import { Component, Input, OnInit } from '@angular/core';
import { ContinueEvent, CsvImporterEvent, GoBackEvent } from '@tmx/operandi';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { RouteService } from 'src/app/services/route.service';
import { EnableContinueButtonEvent } from 'src/app/_models/importer-events/continue-event';
import { EnableImportButtonEvent } from 'src/app/_models/importer-events/enable-import-button-event';
import { ImporterEvent } from 'src/app/_models/importer-events/importer-event';
import { ImporterEventType } from 'src/app/_models/importer-events/importer-event-type';
import { LoadingEvent } from 'src/app/_models/importer-events/loading-event';
import { ShowBackButtonEvent } from 'src/app/_models/importer-events/show-back-button-event';
import { StopState } from 'src/app/_models/state/stopState';
import { Route } from 'src/app/_models/view/route';

@Component({
  selector: 'app-route-import-modal',
  templateUrl: './route-import-modal.component.html',
})
export class RouteImportModalComponent implements OnInit {
  @Input() route: Route;
  showBackButton = false;
  disableInputButton = false;
  enableContinueButton = false;
  hostEvent$ = new Subject<CsvImporterEvent>();
  loading = false;
  stopStates: StopState[];

  constructor(
    private bsModalRef: BsModalRef,
    private routeService: RouteService
  ) {}

  ngOnInit(): void {
    this.routeService.canImportStops(false);
  }

  handleEvent(event: ImporterEvent) {
    setTimeout(() => {
      switch (event.type) {
        case ImporterEventType.Loading:
          this.loading = (event as LoadingEvent).loading;
          break;
        case ImporterEventType.EnableImportButton:
          this.disableInputButton = !(event as EnableImportButtonEvent).enable;
          break;
        case ImporterEventType.EnableContinueButton:
          this.enableContinueButton = (
            event as EnableContinueButtonEvent
          ).enable;
          this.stopStates = (event as EnableContinueButtonEvent).data;
          break;
        case ImporterEventType.ShowBackButton:
          this.showBackButton = (event as ShowBackButtonEvent).show;
          break;
        case ImporterEventType.Complete:
          this.close();
          break;
      }
    });
  }

  goBack() {
    if (this.stopStates) {
      this.routeService.canImportStops(false);
      this.enableContinueButton = false;
    }
    this.hostEvent$.next(new GoBackEvent());
  }

  close() {
    this.bsModalRef.hide();
  }

  import() {
    this.hostEvent$.next(new ContinueEvent());
  }

  continue() {
    this.routeService.canImportStops(true);
    this.hostEvent$.next(new ContinueEvent());
  }
}
